import { NuxtRuntimeConfig } from '@nuxt/types/config/runtime';
import { Framework } from 'vuetify';

// eslint-disable-next-line import/no-mutable-exports
let $config: NuxtRuntimeConfig;
// eslint-disable-next-line import/no-mutable-exports
let $vuetify: Framework;

export function initializeTheme(config: NuxtRuntimeConfig, vuetify: Framework) {
  $config = config;
  $vuetify = vuetify;
}

export { $config, $vuetify };
